// This file is auto-generated - any changes will be lost

// Editor Files
import "../modules/base/js/editor/FieldEditorCheckbox.js";
import "../modules/base/js/editor/FieldEditorDate.js";
import "../modules/base/js/editor/FieldEditorDateTime.js";
import "../modules/base/js/editor/FieldEditorNumber.js";
import "../modules/base/js/editor/FieldEditorRadio.js";
import "../modules/base/js/editor/FieldEditorSelect.js";
import "../modules/base/js/editor/FieldEditorTags.js";
import "../modules/base/js/editor/FieldEditorText.js";
import "../modules/base/js/editor/FieldEditorTextarea.js";
import "../modules/base/js/editor/FieldEditorWysiwyg.js";
import "../modules/base/js/editor/_FieldEditorBase.js";